import { getCiamSessionToken } from './useCiamAuthorize'
import { useStore } from './useStore'

export const useCiamDeleteProfile = () => {
  const { state } = useStore()

  const handleDeleteProfile = async () => {
    if (typeof window === 'undefined') {
      return false
    }

    const sessionToken = getCiamSessionToken() ?? ''
    const userId = state?.ciamUserId ?? ''

    try {
      const response = await fetch(
        `${process.env.GATSBY_API_URL}/ciam/user/${userId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionToken}`,
          },
        }
      )

      return response.ok
    } catch (err) {
      console.error('Error calling CIAM DELETE /ciam/user:', err)
      return false
    }
  }

  return { handleDeleteProfile }
}
